import BlueDotsBackground from '../../BlueDotsBackground';
// import people from '../../content/people';
import images from '../../content/mfpContent';

export default function Articles() {
  return (
    <>
      <BlueDotsBackground />

      <section id="header" className="text-white px-6 py-8">
        <div className="max-w-4xl mx-auto">
          <header className="text-left">
            <h1 className="text-4xl font-bold text-white">
              MFP Impacts on Government Pricing
            </h1>

            <div className="mt-4 flex items-center justify-start gap-4">
              <div className="text-sm text-gray-400">
                <p>06/20/2025</p>
                <p>Written by Sushila Rau</p>
              </div>
              {/* <img
                                src={people[10].image}
                                alt={people[10].name}
                                className="w-10 h-10 rounded-full object-cover border-2 border-white/30 shadow-md"
                            /> */}
            </div>
          </header>
        </div>
      </section>

      {/* Article Section */}
      <section id="article" className="text-white px-6 py-4">
        <div className="flex items-center justify-center min-h-screen">
          <div className="mb-24 max-w-2xl px-4 text-left">
            <p className="text-sm text-gray-300">
              <span className="font-bold text-white">
                As manufacturers look to operationalize MFP effectuation, they
                must also understand the downstream consequences for Government
                Pricing (GP), financial liabilities, and compliance.
              </span>{' '}
              <br />
              <br />
              Beginning January 1, 2026, CMS will enforce the first round of
              MFPs on selected single-source Medicare Part D drugs under the
              IRA. This marks a fundamental shift across the U.S. drug pricing
              ecosystem, with implications spanning Medicaid, 340B, Medicare and
              contracting. <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-chart-pie-simple-circle-dollar mr-2 text-2xl"></i>
                Medicaid{' '}
              </span>{' '}
              <br />
              <br />
              When MFP is implemented, MFP will be excluded from the Average
              Manufacturer Price (AMP). However, it will be included for
              consideration in Best Price (BP) if it is the lowest net price
              available. For the example of single source drugs, Medicaid rebate
              calculations use the greater of 23.1% of AMP or the difference
              between AMP and Best Price to determine the basic portion of the
              Unit Rebate Amount (URA). Therefore, if MFP sets BP and the
              difference between AMP and MFP exceeds 23.1% of AMP, then the URA
              will be set by the difference of AMP and MFP. In this scenario,
              this effectively means the Medicaid rebate amount is being driven
              by MFP. This results in a higher rebate per unit and increases
              Medicaid rebate liability for the manufacturer.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-hospital mr-2 text-2xl"></i>
                340B
              </span>{' '}
              <img
                src={images[7]}
                alt={images[7]}
                className="w-30 h-20 mx-auto shadow-md"
              />
              The 340B Drug Pricing Program, which provides discounted
              outpatient drugs to safety net providers, faces increased
              complexity in the MFP era. The 340B ceiling price is calculated as
              AMP minus URA, and if MFP sets the Medicaid BP, then the URA could
              potentially increase as described previously. In effect, this
              means manufacturers are required to offer the lower of MFP or the
              340B price to covered entities. A higher URA reduces the 340B
              ceiling price, meaning manufacturers receive less revenue per unit
              sold through PHS contracts. This relationship increases financial
              pressure on manufacturers and adds complexity to government
              pricing compliance, requiring more analysis of the impact of MFP
              on multiple downstream liabilities.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-syringe mr-2 text-2xl"></i>
                Medicare Part B
              </span>{' '}
              <img
                src={images[6]}
                alt={images[6]}
                className="w-30 h-20 mx-auto shadow-md"
              />
              Starting in 2026, manufacturers must provide access to the MFP for
              selected Medicare Part D drugs, with MFP applying to Medicare Part
              B drugs beginning in 2028. Currently, Part B drugs are reimbursed
              at Average Sales Price (ASP) plus 6%, but once MFP is implemented,
              reimbursement will shift to the lower MFP plus 6% rate, reducing
              provider payment.
              <br />
              <br />
              Since MFP is included in ASP calculations, it will place downward
              pressure on ASP values. This has broader implications for Part B
              negotiated drugs, the MFP ceiling is calculated as the lower of a
              manufacturer’s ASP or a defined percentage of the average
              non-FAMP. This effectively makes ASP a ceiling for MFP, creating a
              feedback loop where a lower ASP pulls MFP down and, in turn, the
              lower MFP continues to suppress ASP over time.
              <br />
              <br />
              Additionally, many commercial and Medicare Advantage (MA)
              contracts could potentially be tied to ASP. Analyzing how MFP
              implementation influences ASP will be critical to understanding
              the potential impact on private and MA reimbursement dynamics.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-landmark-dome mr-2 text-2xl"></i>
                Federal
              </span>{' '}
              <br />
              <br />
              MFP is excluded from Non-Federal AMP (Non-FAMP) and does not
              directly influence FSS pricing. However, for selected Part D
              drugs, the 2021 Non-FAMP inflated by CPI-U will serve as the MFP
              ceiling through 2027. This makes Non-FAMP a critical input in
              determining the upper limit of MFP for applicable drugs. As a
              result, inaccurate Non-FAMP reporting could distort MFP ceilings,
              underscoring the growing importance of precise and compliant GP
              reporting for manufacturers.
              <br />
              <br />
              <span className="font-bold text-white">
                <i className="fas fa-arrow-right mr-2 text-2xl"></i>
                Moving Forward
              </span>{' '}
              <br />
              <br />
              MFP implementation compresses margins, increases operational
              burden, and has potential downstream implications across Medicaid,
              340B, Medicare and contracting. To navigate these government
              pricing impacts beyond 2026, pharmaceutical manufacturers must
              leverage solutions that can accurately forecast the GP
              implications of MFP and enhance infrastructure to support
              compliance and pricing strategy across all affected channels.{' '}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
